import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import GraciasPage from "./components/GraciasPage";
import PrivacidadPage from "./components/PrivacidadPage";
import TerminosPage from "./components/TerminosPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/gracias" element={<GraciasPage />} />
          <Route path="/privacidad" element={<PrivacidadPage />} />
          <Route path="/politica-privacidad" element={<PrivacidadPage />} />
          <Route path="/terminos" element={<TerminosPage />} />
          <Route path="/terminos-condiciones" element={<TerminosPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
